import Tables from 'src/class/Tables';
import ColorFormatter from 'src/components/Layouts/ColorFormatter.vue';
import SwitchFormatter from 'src/components/Layouts/SwitchFormatter.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'two_name',
      label: i18n.t('common_words.description'),
      minWidth: 120,
      sortable: true,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'unit',
      label: i18n.t('labor.unit'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'label_is_calculated',
      label: `${i18n.t('devices.calculated')}?`,
      sortable: true,
      minWidth: 120,
      align: 'center',
      formatter: SwitchFormatter,
    },
    {
      prop: 'label_is_probe',
      label: `${i18n.t('devices.probe_belongs')}?`,
      sortable: true,
      minWidth: 120,
      align: 'center',
      formatter: SwitchFormatter,
    },
    {
      prop: 'field',
      label: i18n.t('common_words.value'),
      sortable: true,
      minWidth: 120,
    },
    {
      prop: 'color',
      label: i18n.t('common_words.color'),
      minWidth: 80,
      sortable: true,
      colors: true,
      formatter: ColorFormatter,
    },
    {
      prop: 'grouping_number',
      label: i18n.t('common_words.grouping_number'),
      sortable: true,
      minWidth: 120,
      align: 'center',
    },
    {
      prop: 'type_graph2',
      label: i18n.t('common_words.type_graph'),
      sortable: true,
      minWidth: 120,
      align: 'center',
    },
  ];

  return { Table };
};

export default configTable;
